<template>
  <div class="col-12">
    <div class="d-flex flex-md-column">
      <section id="desc">
        <div
          class="d-flex flex-column flex-md-row about-wrap align-items-center"
        >
          <div class="about-text text-justify second">
            <p>
              我國政府於2003年頒佈「挑戰2008：國家發展重點計畫」白皮書，因應當前全球化、數位化之國際新競爭模式訂定國家十大重點計畫，其中「文化創意產業發展計畫」為子計畫之一，並由教育部專責推動人才培訓。
            </p>
            <p>
              惟文創產業發展應具國際視野薰陶，並借重國外一流校院或公司合作培訓，教育部於2005年啟動「藝術與設計菁英海外培訓計畫」，持續推動至今共5組規模。
            </p>
            <p>
              本計畫亦著重於產學合作的溝通網絡，期望使計畫之成效更為彰顯。除了發展並推廣產學合作教學資源之外，也希冀促成學校與產業界長期合作關係，加強跨領域文化創意產業人才培育，帶動文創產業整體的發展與水準的提升。
            </p>
          </div>
          <div
            class="about-img d-none d-md-block"
            :style="{ backgroundImage: `url(${intro})` }"
          ></div>
        </div>

        <div
          class="n-mx-rem1 mt-5 d-sm-none mobile-divider"
          style="width: 100vw"
        >
          <img :src="divider" alt="" class="w-100" />
        </div>
      </section>
    </div>
    <section id="gruop-intro" class="mt-5">
      <div class="mobile-h3 d-md-none text-center mb-2 mt-3">各組特色</div>
      <div
        class="
          d-flex
          flex-column flex-md-row
          about-wrap
          align-items-center
          n-mx-rem11
        "
      >
        <div
          class="about-img"
          :style="{
            backgroundImage: `url(${groupImage[$route.params.groupId[5] - 1]})`,
          }"
        ></div>

        <div class="about-text text-justify first px-4 pe-sm-0">
          <div class="title mb-2">
            {{ groups[$route.params.groupId[5] - 1] }}
          </div>

          {{ groupIntro[$route.params.groupId[5] - 1] }}
          <div v-html="groupImgSrc[$route.params.groupId[5] - 1]"></div>
        </div>
      </div>
    </section>

    <div class="n-mx-rem1 mt-5 d-md-none mobile-divider">
      <img :src="divider" alt="" class="w-100" />
    </div>
    <div class="d-none d-lg-block mt-5"></div>
    <!-- features -->
    <div class="mobile-h3 d-md-none text-center mt-3">計畫目標</div>
    <section id="features" class="n-mx-rem1 mt-2">
      <div class="features-wrapper">
        <template v-for="(item, i) in features" :key="i">
          <div class="d-inline-flex features-unit flex-column">
            <div class="text-justify small-text w-100 d-none d-md-block">
              <template v-if="i + 1 < 10">0</template>{{ i + 1 }}
            </div>
            <Feature :info="item"></Feature>
          </div>
        </template>
      </div>
      <div class="arrows text-end d-flex justify-content-end">
        <button class="flex-center scroll-btn scroll-left">
          <img :src="arrowLeft" alt="" />
        </button>
        <button class="flex-center scroll-btn scroll-right">
          <img :src="arrowRight" alt="" />
        </button>
      </div>
    </section>

    <div class="n-mx-rem1 mt-5 d-md-none mobile-divider">
      <img :src="divider" alt="" class="w-100" />
    </div>

    <div class="mobile-h3 d-md-none text-center mb-2 mt-3">辦理方式及時程</div>
    <section id="schedule" class="d-none d-md-block mb-4 mt-5">
      <div class="accordion-title mobile-body mb-3">計畫時程</div>

      <div class="small-text schedule-wrap">
        <div class="d-flex">
          <div class="schedule-phase d-flex flex-column flex-fill">
            <div class="phase-title h4-style d-flex">
              <img :src="progress1" alt="" class="" /><span class="">報名</span
              ><span class="title-line flex-grow-1"></span>
            </div>
            <div class="phase-content">
              <div class="activity old-small-bold">簡章公告</div>
              <div class="date old-small">
                {{ scheduleByGroup[0].p1i1 }}
              </div>
            </div>
            <div class="phase-content">
              <div class="activity old-small-bold">報名截止</div>
              <div class="date old-small">
                {{ scheduleByGroup[0].p1i2 }}
              </div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column flex-fill">
            <div class="phase-title h4-style d-flex">
              <img :src="progress2" alt="" /><span class="">國內初審</span
              ><span class="title-line flex-grow-1"></span>
            </div>
            <div class="phase-content">
              <div class="activity old-small-bold">國內初審名單公告</div>
              <div class="date old-small">
                {{ scheduleByGroup[0].p2i1 }}
              </div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column flex-fill">
            <div class="phase-title h4-style d-flex">
              <img :src="progress3" alt="" /><span class="">國內研習</span
              ><span class="title-line flex-grow-1"></span>
            </div>
            <div class="phase-content">
              <div class="activity old-small-bold">國內研習營</div>
              <div class="date old-small">
                {{ scheduleByGroup[$route.params.groupId[5] - 1].p3i1 }}
              </div>
            </div>
            <div class="phase-content">
              <div class="activity old-small-bold">國內研習營排序公告</div>
              <div class="date old-small">
                {{ scheduleByGroup[$route.params.groupId[5] - 1].p3i2 }}
              </div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column flex-fill">
            <div class="phase-title h4-style d-flex">
              <img :src="progress4" alt="" /><span class="">國內複審</span
              ><span class="title-line flex-grow-1"></span>
            </div>
            <div class="phase-content">
              <div class="activity old-small-bold">繳交語言成績及志願表</div>
              <div class="date old-small">
                {{ scheduleByGroup[$route.params.groupId[5] - 1].p4i1 }}
              </div>
            </div>
            <div class="phase-content">
              <div class="activity old-small-bold">國內複審合格名單公告</div>
              <div class="date old-small">
                {{ scheduleByGroup[0].p4i2 }}
              </div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column flex-fill">
            <div class="phase-title h4-style d-flex">
              <img :src="progress5" alt="" /><span class="">海外決選</span
              ><span class="title-line flex-grow-1"></span>
            </div>
            <div class="phase-content">
              <div class="activity old-small-bold">海外學校申請</div>
              <div class="date old-small">
                {{ scheduleByGroup[0].p5i1 }}
              </div>
            </div>
            <div class="phase-content">
              <div class="activity old-small-bold">放榜及正備取通知</div>
              <div class="date old-small">
                {{ scheduleByGroup[0].p5i2 }}
              </div>
            </div>
          </div>
          <div class="schedule-phase d-flex flex-column flex-fill">
            <div class="phase-title h4-style d-flex">
              <img :src="progress6" alt="" />出發！
            </div>
            <div class="phase-content">
              <div class="activity old-small-bold">海外培訓</div>
              <div class="date old-small">
                {{ scheduleByGroup[0].p6i1 }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="arrows text-end d-flex justify-content-end">
        <button class="flex-center scroll-btn scroll-left">
          <img :src="arrowLeft" alt="" />
        </button>
        <button class="flex-center scroll-btn scroll-right">
          <img :src="arrowRight" alt="" />
        </button>
      </div>
    </section>
    <!-- accordions -->
    <section id="registration-info" class="mt-0" v-if="regInfo">
      <div
        class="
          d-flex
          justify-content-between
          reg-accordion
          flex-wrap flex-md-nowrap flex-md-nowrap
        "
      >
        <div class="accordion-title mobile-body flex-shrink-0">
          徵選對象
          <div class="old-mini">以下規定請以公告簡章為準</div>
        </div>
        <div class="order-4 order-md-2" id="collapse1">
          <div
            class="p-2 pt-0 small-text text-justify"
            v-html="regInfo.target"
          ></div>
        </div>
      </div>
      <div
        class="
          d-flex
          justify-content-between
          reg-accordion
          flex-wrap flex-md-nowrap
        "
      >
        <div class="accordion-title mobile-body flex-shrink-0">徵選方式</div>
        <div class="" id="collapse2">
          <div class="p-2 pt-0 small-text" v-html="regInfo.detail"></div>
        </div>
      </div>
      <div
        class="
          d-flex
          justify-content-between
          reg-accordion
          flex-wrap flex-md-nowrap
        "
      >
        <div class="accordion-title mobile-body flex-shrink-0">補助經費</div>
        <div class="" id="collapse3">
          <div class="p-2 pt-0 small-text" v-html="regInfo.subsidy"></div>
        </div>
      </div>
      <div class="d-flex justify-content-between reg-accordion d-md-none">
        <div class="accordion-title mobile-body flex-shrink-0">辦理時程</div>
      </div>
      <div class="d-md-none" id="collapse4">
        <div class="small-text schedule-wrap-mobile">
          <div class="d-flex flex-column">
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress1" alt="" class="" /><span class=""
                  >報名</span
                ><span class="title-line flex-grow-1"></span>
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    簡章公告
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p1i1 }}
                  </div>
                </div>
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    報名截止
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p1i2 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress2" alt="" /><span class=""
                  >國內<br />初審</span
                ><span class="title-line flex-grow-1"></span>
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    國內初審名單公告
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p2i1 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress3" alt="" /><span class=""
                  >國內<br />研習</span
                ><span class="title-line flex-grow-1"></span>
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    國內研習營
                  </div>
                  <div class="group-tags">
                    <span class="tag">數位動畫</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p3i1 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">視覺傳達</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[1].p3i1 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">時尚設計</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[2].p3i1 }}
                  </div>
                </div>
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    國內研習營排序公告
                  </div>
                  <div class="group-tags">
                    <span class="tag">數位動畫</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p3i2 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">視覺傳達</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[1].p3i2 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">時尚設計</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[2].p3i2 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress4" alt="" /><span class=""
                  >國內<br />複審</span
                ><span class="title-line flex-grow-1"></span>
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    繳交語言成績及志願表
                  </div>
                  <div class="group-tags">
                    <span class="tag">數位動畫</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p4i1 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">視覺傳達</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[1].p4i1 }}
                  </div>
                  <div class="group-tags">
                    <span class="tag">時尚設計</span>
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[2].p4i1 }}
                  </div>
                </div>
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    國內複審合格名單公告
                  </div>
                  <div class="date old-small mobile-small">擇期辦畢公告</div>
                </div>
              </div>
            </div>
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress5" alt="" /><span class=""
                  >海外<br />決選</span
                ><span class="title-line flex-grow-1"></span>
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    海外學校申請
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p5i1 }}
                  </div>
                </div>
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    放榜及正備取通知
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p5i2 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="schedule-phase d-flex">
              <div class="phase-title mobile-h4 h4-style d-flex flex-column">
                <img :src="progress6" alt="" />出發
              </div>
              <div class="phase-content-wrap">
                <div class="phase-content">
                  <div class="activity old-small-bold mobile-small">
                    海外培訓
                  </div>
                  <div class="date old-small mobile-small">
                    {{ scheduleByGroup[0].p6i1 }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <img :src="applyScheduleM" alt="" /> -->
        </div>
      </div>
    </section>
    <!-- institute -->
    <section id="institutes" class="n-mx-rem1 mt-5">
      <div class="n-mx-rem1 mt-5 d-md-none mobile-divider">
        <img :src="divider" alt="" class="w-100" />
      </div>
      <div class="mobile-h3 d-md-none text-center mb-2 mt-3">海外培訓機構</div>
      <div class="institutes-wrapper">
        <template
          v-for="(item, i) in institutesByGroup[$route.params.groupId[5] - 1]"
          :key="i"
        >
          <div class="d-inline-flex institutes-unit flex-column">
            <div class="text-justify small-text w-100 d-none d-md-block">
              {{ item.nation }}
            </div>
            <Institute :info="item" class="d-none d-sm-block"></Institute>
            <InstituteM :info="item" class="d-sm-none"></InstituteM>
          </div>
        </template>
      </div>
      <div class="arrows text-end d-flex justify-content-end">
        <button class="flex-center scroll-btn scroll-left">
          <img :src="arrowLeft" alt="" />
        </button>
        <button class="flex-center scroll-btn scroll-right">
          <img :src="arrowRight" alt="" />
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import 'overlayscrollbars/css/OverlayScrollbars.min.css';
import OverlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars.min';

import Institute from '@/components/about/Institute.vue';
import InstituteM from '@/components/about/InstituteM.vue';
import Feature from '@/components/about/Feature.vue';

import divider from '@/assets/img/divider.svg';
import arrowLeft from '@/assets/img/arrow-left.svg';
import arrowRight from '@/assets/img/arrow-right.svg';
import intro from '@/assets/img/about/intro.jpg';
import g1 from '@/assets/img/about/g1.png';
import g2 from '@/assets/img/about/g2.jpg';
import g3 from '@/assets/img/about/g3.jpg';
// import about1 from '@/assets/img/about1.png';
// import about2 from '@/assets/img/about2.png';
import feat1 from '@/assets/img/feat1.png';
import feat2 from '@/assets/img/feat2.png';
import feat3 from '@/assets/img/feat3.png';
import feat4 from '@/assets/img/feat4.png';
import feat5 from '@/assets/img/feat5.png';
// import ins1 from '@/assets/img/ins1.jpg';
// import ins2 from '@/assets/img/ins2.jpg';
// import ins3 from '@/assets/img/ins3.jpg';
import progress1 from '@/assets/img/about/progress1.svg';
import progress2 from '@/assets/img/about/progress2.svg';
import progress3 from '@/assets/img/about/progress3.svg';
import progress4 from '@/assets/img/about/progress4.svg';
import progress5 from '@/assets/img/about/progress5.svg';
import progress6 from '@/assets/img/about/progress6.svg';
import applySchedule from '@/assets/img/apply-schedule.png';
import applyScheduleM from '@/assets/img/about/timeline_m.png';

// api
// import { getInstituteList } from '@/api/institute';
import { getReg } from '@/api/reg';
import { getScheduleList } from '@/api/schedule';

import store from '@/store';
import institutesByGroup from '@/assets/js/institutes.json';

export default {
  name: 'About',
  components: {
    Institute,
    InstituteM,
    Feature,
  },
  data() {
    return {
      institutesByGroup,
      intro,
      progress1,
      progress2,
      progress3,
      progress4,
      progress5,
      progress6,
      divider,
      arrowLeft,
      arrowRight,
      applySchedule,
      applyScheduleM,
      fScroll: null,
      iScroll: null,
      groups: ['數位動畫組', '視覺傳達設計組', '時尚設計組'],
      features: [{
        title: ['跨國際、跨文化', '菁英人才培訓'],
        desc: '以藝術與設計相關系所之學生為對象，透過公開徵選方式，審慎甄試國內優秀設計菁英，前往歐、美、日、澳等藝術與設計領域知名機構，進行為期一年之培訓或實習。',
        image: feat1,
      },
      {
        title: ['加強實習課程', '與國際產業接軌'],
        desc: '學員除了進修美、英、法、日等地著名藝術與設計名校課程之外，亦有機會觀摩知名文化創意產業製作公司實際作業狀況，參與實務實習，萃取國外優秀新知與技術，引進最新觀念與關鍵知識。',
        image: feat3,
      }, {
        title: ['引進國內業界師資', '達成產學合一'],
        desc: '邀請多位藝術設計產業界專家，擔任國內評審委員，遴選國內設計菁英。研習營課程也延攬國內外知名產業界專業人士前來授課，給予學員多角度視野，結合設計概念等多方面課程，增進產學合作的溝通網絡。',
        image: feat5,
      }, {
        title: ['建立國際產業交流平台', '提高國際能見度'],
        desc: '透過海外培訓機構講師來台，提高外國講師對臺灣文創及設計業界的了解，以期增加臺灣文創業的國際能見度，建立臺灣設計業界與國際業界交流與對談的可能性。',
        image: feat2,
      }, {
        title: ['擴展學習成果', '形成設計教育接軌之回流體系'],
        desc: '培訓學員於培訓期間，定期與大眾分享海外學習概況與心得。學員返國後亦藉本計畫各項教學活動強化與國內師生交流互動，分享海外培訓經歷與經驗傳承，有效擴展學習成效，提升大專校院整體設計科系的創作氛圍。',
        image: feat4,
      }],
      groupImgSrc: [
        '（圖片提供：109年度學員/黃亞文）',
        '（圖片提供：109年度學員/<a class="group-src" href="//syuanyunhuang.myportfolio.com" target="_blank">黃軒筠</a>）',
        '（圖片提供：109年度學員/陳曉墨）',
      ],
      groupIntro: [
        '數位動畫為新興文化產業與內容之核心，亦是目前國家發展計畫的重點產業。此領域結合了科技、美學與文化藝術，為備受矚目的明星產業。近年來除了具有豐富製作經驗的美、日先進國家之外，其他開發中國家，如南韓、印度新加坡也投入可觀的資源發展這項文化創意產業。',
        '視覺傳達設計在各類商業活動中扮演重要角色，任何產品與廣告透過設計者的巧思與創意，經由適當且美觀的設計、包裝後，提升產品整體的價值與效益。平面設計作為知識型的服務產業及新興學科，在現今的企業競爭確實舉足輕重，同時目前消費市場追求更精緻且時尚的品牌服務、產品包裝、廣告和形象設計，因此在「文化創意產業」的平面設計相關產業已列為多項重點發展範疇。',
        '能將傳統紡織工業提升到新的經濟層次外，更能藉由把創新以及個人風格注入到傳統產業之中，進而做到提升國力、陶冶藝術人文的發展。時尚產業近一世紀於全球的人文發展變革，造就了舉世聞名的紐約、巴黎、倫敦時裝週等國際盛會，其中的技術層面和專業知識，即是代表各國間文化產業競爭的軟實力。'],
      groupImage: [g1, g2, g3],
      // images: [ins1, ins2],
      ins: [],
      regInfo: null,
      schedule: [],
    };
  },
  computed: {
    // institutesByGroup() {
    //   const rst = [[], [], []];
    //   this.ins.forEach((ele) => {
    //     rst[ele.group - 1].push(ele);
    //   });
    //   return rst;
    // },
    scheduleByGroup() {
      const rst = [[], [], []];
      this.schedule.forEach((ele) => {
        rst[ele.id - 1] = ele;
      });
      return rst;
    },
  },
  methods: {
    getPosition(element) {
      let e = element;
      let x = 0;
      let y = 0;
      while (e) {
        x += e.offsetLeft - e.scrollLeft + e.clientLeft;
        y += e.offsetTop - e.scrollLeft + e.clientTop;
        e = e.offsetParent;
      }
      return { x, y };
    },
    mouseDownHandlerF(e) {
      const ele = document.querySelector('#features .os-viewport');
      this.pos = {
        // The current scroll
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };
      ele.style.cursor = 'grabbing';
      ele.style.userSelect = 'none';
      ele.addEventListener('mousemove', this.mouseMoveHandlerF);
      ele.addEventListener('mouseup', this.mouseUpHandlerF);
      ele.addEventListener('mouseleave', this.mouseUpHandlerF);
    },
    mouseMoveHandlerF(e) {
      // How far the mouse has been moved
      const dx = e.clientX - this.pos.x;
      const dy = e.clientY - this.pos.y;

      const ele = document.querySelector('#features .os-viewport');
      ele.scroll({ x: this.pos.top - dy, y: this.pos.left - dx }, 500);
      // Scroll the element
      ele.scrollTop = this.pos.top - dy;
      ele.scrollLeft = this.pos.left - dx;
    },
    mouseUpHandlerF() {
      const ele = document.querySelector('#features .os-viewport');
      ele.removeEventListener('mousemove', this.mouseMoveHandlerF);
      ele.style.cursor = 'grab';
      ele.style.removeProperty('user-select');
    },
    mouseDownHandlerI(e) {
      const ele = document.querySelector('#institutes .os-viewport');
      this.pos = {
        // The current scroll
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };
      ele.style.cursor = 'grabbing';
      ele.style.userSelect = 'none';
      ele.addEventListener('mousemove', this.mouseMoveHandlerI);
      ele.addEventListener('mouseup', this.mouseUpHandlerI);
      ele.addEventListener('mouseleave', this.mouseUpHandlerI);
    },
    mouseMoveHandlerI(e) {
      // How far the mouse has been moved
      const dx = e.clientX - this.pos.x;
      const dy = e.clientY - this.pos.y;

      const ele = document.querySelector('#institutes .os-viewport');
      ele.scroll({ x: this.pos.top - dy, y: this.pos.left - dx }, 500);
      // Scroll the element
      ele.scrollTop = this.pos.top - dy;
      ele.scrollLeft = this.pos.left - dx;
    },
    mouseUpHandlerI() {
      const ele = document.querySelector('#institutes .os-viewport');
      ele.removeEventListener('mousemove', this.mouseMoveHandlerI);
      ele.style.cursor = 'grab';
      ele.style.removeProperty('user-select');
    },
    sideMenuOnScroll() {
      const ginfoPos = this.getPosition(document.getElementById('gruop-intro'));
      const descPos = this.getPosition(document.getElementById('desc'));
      const featPos = this.getPosition(document.getElementById('features'));
      const regPos = this.getPosition(document.getElementById('schedule'));
      // const insPos = this.getPosition(document.getElementById('institutes'));
      if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 500) {
        this.curSection = '海外培訓機構';
        this.$emit('setCurSection', '海外培訓機構');
      } else if (window.scrollY + 400 > regPos.y) {
        this.curSection = '辦理方式<br/>及時程';
        this.$emit('setCurSection', '辦理方式<br/>及時程');
      } else if (window.scrollY + 400 > featPos.y) {
        this.curSection = '計畫目標';
        this.$emit('setCurSection', '計畫目標');
      } else if (window.scrollY + 400 > ginfoPos.y) {
        this.curSection = '各組特色';
        this.$emit('setCurSection', '各組特色');
      } else if (window.scrollY + 400 > descPos.y) {
        this.curSection = '計畫緣起';
        this.$emit('setCurSection', '計畫緣起');
      }
    },
  },
  created() {
    // const filter = { order: 'sort asc, updated_at desc' };
    // getInstituteList({ filter }).then((response) => {
    //   this.ins = response;
    // });
    getReg().then((response) => {
      this.regInfo = response;
    });
    getScheduleList().then((response) => {
      this.schedule = response;
    });
  },
  mounted() {
    this.sideMenuOnScroll();
    window.addEventListener('scroll', this.sideMenuOnScroll);
    const cxt = this;
    setTimeout(() => {
      const settings = {
        className: 'os-theme-dark',
        sizeAutoCapable: true,
        paddingAbsolute: true,
        overflowBehavior: {
          x: 'scroll',
          y: 'hidden',
        },
        scrollbars: {
          clickScrolling: true,
          visibility: 'auto',
        },
        callbacks: {
        },
      };
      settings.callbacks.onInitialized = () => document.querySelector('#features .os-viewport').addEventListener('mousedown', cxt.mouseDownHandlerF);
      settings.callbacks.onScroll = function () {
        if (this.scroll().position.x === 0) {
          document.getElementById('features').classList.remove('left-fade');
        } else {
          document.getElementById('features').classList.add('left-fade');
        }
      };
      this.fScroll = OverlayScrollbars(document.querySelector('.features-wrapper'), settings);
      // fScroll.scroll({ x: 0 });
      settings.callbacks.onInitialized = () => document.querySelector('#institutes .os-viewport').addEventListener('mousedown', cxt.mouseDownHandlerI);
      settings.callbacks.onScroll = function () {
        if (this.scroll().position.x === 0) {
          document.getElementById('institutes').classList.remove('left-fade');
        } else {
          document.getElementById('institutes').classList.add('left-fade');
        }
      };
      this.iScroll = OverlayScrollbars(document.querySelector('.institutes-wrapper'), settings);
      // iScroll.scroll({ x: 0 });

      const page = document.querySelector('.page');
      const computedStyle = getComputedStyle(page);
      let sectionWidth = page.clientWidth; // width with padding
      sectionWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);

      document.querySelector('#features .scroll-left').addEventListener('click', () => this.fScroll.scroll({ x: (page.clientWidth < 575) ? `-= ${sectionWidth}` : '-= 420' }));
      document.querySelector('#features .scroll-right').addEventListener('click', () => this.fScroll.scroll({ x: (page.clientWidth < 575) ? `+= ${sectionWidth}` : '+= 420' }));
      document.querySelector('#institutes .scroll-left').addEventListener('click', () => this.iScroll.scroll({ x: (page.clientWidth < 575) ? `-= ${sectionWidth}` : '-= 360' }));
      document.querySelector('#institutes .scroll-right').addEventListener('click', () => this.iScroll.scroll({ x: (page.clientWidth < 575) ? `+= ${sectionWidth}` : '+= 360' }));
      const sScroll = OverlayScrollbars(document.querySelectorAll('.schedule-wrap'), {
        className: 'os-theme-dark',
        sizeAutoCapable: true,
        paddingAbsolute: true,
        scrollbars: {
          clickScrolling: true,
        },
      });

      document.querySelector('#schedule .scroll-left').addEventListener('click', () => sScroll.scroll({ x: '-= 200px' }));
      document.querySelector('#schedule .scroll-right').addEventListener('click', () => sScroll.scroll({ x: '+= 200px' }));
    }, 50);
    setTimeout(() => {
      store.commit('setLoadingState', { status: false });
    }, 500);

    // side menu click event
    const menuItems = document.querySelectorAll('.lv1 a');
    menuItems.forEach((mi) => mi.addEventListener('click', (e) => {
      const yOffset = -170;
      const element = document.querySelector(e.target.getAttribute('href'));
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }));
  },
  unmounted() {
    window.removeEventListener('scroll', this.sideMenuOnScroll);
  },
  watch: {
    '$route.params.groupId': function () {
      // 切換組別時回到開頭
      if (this.fScroll) this.fScroll.scroll({ x: 0 });
      if (this.iScroll) this.iScroll.scroll({ x: 0 });
    },
  },
};
</script>

<style lang="stylus" scoped>
section + section
  margin-top: 96px;

.about-wrap + .about-wrap
  margin-top: 96px;

.about-img
  width: 55%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 360px;

.about-text
  width: 45%;
  min-width: 45%;

.institute-block, .feature-block
  cursor: grab;

@media screen and (min-width: 991px)
  .about-text
    &.first
      padding-left: 36px !important;

    &.second
      padding-right: 36px !important;

.reg-accordion
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid $monoc4;

.accordion-title
  width: 160px;
  font-weight: bold;
  font-size: 20px;
  line-height: 150%;

.btn-trigger
  &:focus, &:hover, &:active
    box-shadow: none;

  .plus
    display: block;

  .minus
    display: none;

  &:not(.collapsed)
    .minus
      display: block;

    .plus
      display: none;

#schedule
  position: relative;

  .schedule-wrap
    white-space: nowrap;
    padding-bottom: 12px;

  .schedule-phase + .schedule-phase
    padding-left: 10px;
    margin-bottom: 16px;

  .phase-title
    margin-bottom: 16px;

    img
      width: 24px;
      height: 24px;
      margin-right: 4px;

  .title-line
    height: 0.6em;
    border-bottom: solid 1px $monoc4;
    margin-left: 4px;

  .phase-content + .phase-content
    margin-top: 16px;

.schedule-wrap-mobile
  border: 1px solid #BCB8B1;
  border-radius: 20px;
  padding: 20px 0;

  .schedule-phase + .schedule-phase
    .phase-title, .phase-content-wrap
      padding-top: 20px;

  .phase-title
    width: 80px;
    align-items: center;

    // padding: 0 20px;
    img
      width: 36px;
      height: 36px;
      margin-bottom: 4px;

  .phase-content-wrap
    border-left: 1px solid $monoc4;
    padding-left: 20px;

  .phase-content + .phase-content
    margin-top: 20px;

  .group-tags
    margin: 6px 0;

    .tag
      border: 1px solid $monoc4;
      border-radius: 20px;
      font-size: 11px;
      padding: 4px 6px;

    .tag + .tag
      margin-left: 6px;

@media screen and (max-width: 1200px)
  .title-line
    width: 30px;

#features, #institutes
  position: relative;

.features-wrapper, .institutes-wrapper
  padding-bottom: 30px;
  white-space: nowrap;
  cursor: grab;

.features-unit
  width: 420px;
  height: 400px;
  overflow: hidden;
  white-space: normal;

.institutes-unit
  width: 360px;
  white-space: normal;

// @media screen and (min-width: 768px)
// .features-unit
// height: 460px;
@media screen and (min-width: 576px)
  .institutes-unit
    width: 360px;
    height: 460px;
    overflow: hidden;

@media screen and (max-width: 767.5px)
  #features
    // height: 625px;
    .features-wrapper, .features-unit
      height: 100% !important;

  .features-wrapper, .institutes-wrapper
    padding-bottom: 6px;

  section + section
    margin-top: 0;

  .about-text, .about-img
    width: 100%;
    // min-width: 100%;

  .about-img
    margin-bottom: 24px;

  .about-text
    &.first, &.second
      padding: 0;

#features, #institutes, .mobile-divider
  width: 100% !important;

@media screen and (min-width: 768px)
  #features, #institutes
    &:after, &.left-fade:before
      content: '';
      position: absolute;
      z-index: 1;
      bottom: 30px;
      pointer-events: none;
      background-image: linear-gradient(to right, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);
      width: 50px;
      height: 100%;

    &:after
      right: -15px;
      background-image: linear-gradient(to right, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);

    &.left-fade:before
      left: -15px;
      background-image: linear-gradient(to left, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);

@media screen and (max-width: 575.7px)
  .features-unit, .institutes-unit
    width: 100%;
</style>

<style lang="stylus">
.group-src
  &, &:hover, &:focus, &:active
    color: $monoc4 !important;

.os-scrollbar-track
  background-color: $monoc2 !important;

.os-scrollbar-handle
  background-color: $monoc4 !important;

.os-host-scrollbar-horizontal-hidden + .arrows
  display: none !important;
</style>
